module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav",
    class: {
      open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__open-bg",
    class: {
      open: _vm.isClicked
    },
    on: {
      "click": _vm.toggle2
    }
  }), _c('div', {
    staticClass: "nav__bg"
  }, [_c('div', {
    staticClass: "nav__container",
    class: {
      open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__logo",
    class: {
      scrolled: this.$store.state.nav, open: _vm.isClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "nav__logo--image",
    attrs: {
      "src": "https://www.southshoreortho.com/wp-content/uploads/southshorelogo.png",
      "alt": "Logo"
    }
  })])], 1), _c('div', {
    staticClass: "nav__link-container",
    class: {
      scrolled: this.$store.state.nav, open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__hamburger",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span'), _c('span'), _c('span'), _c('span')]), _c('div', {
    staticClass: "nav__outer-link-1",
    class: {
      open: _vm.isClicked
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+15168683131"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("516-783-1121")])], 1)])]), _c('div', {
    staticClass: "nav__links",
    class: {
      open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__links-container"
  }, [_vm._l((_vm.links), function(link) {
    return _c('div', {
      staticClass: "nav__link",
      on: {
        "click": _vm.toggle3
      }
    }, [(link.name !== "redirect" && link.name !== "accessibility") ? _c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name))]) : _vm._e()], 1)
  }), _c('div', {
    staticClass: "nav__special"
  }, [_c('div', {
    staticClass: "nav__icon-links"
  }, [_c('div', {
    staticClass: "nav__icon-1"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/pages/South-Shore-Smiles/174452989420378"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "fb-icon"
    }
  })], 1)]), _c('div', {
    staticClass: "nav__icon-3"
  }, [_c('a', {
    attrs: {
      "href": "https://www.google.com/search?q=south+shore+smiles+orthodontics&oq=south+shore+smiles+orthodontics&aqs=chrome..69i57j69i60l3j0l2.12803j0j1&sourceid=chrome&ie=UTF-8#lrd=0x89c27ec45da1fd95:0xc1de31c1e736ecde,1"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "google-plus"
    }
  })], 1)])]), _vm._m(0), _c('div', {
    staticClass: "nav__link-1"
  }, [_c('router-link', {
    attrs: {
      "to": "/Contact-us"
    }
  }, [_vm._v("Request Appointment")])], 1), _c('div', {
    staticClass: "nav__link-1"
  }, [_c('a', {
    attrs: {
      "href": "tel:+15167831121"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v("516-783-1121")], 1)])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav__link-1"
  }, [_c('a', {
    attrs: {
      "href": "https://patient-portal-prd-cluster-3.sesamecommunications.com/sukoffortho/index.html"
    }
  }, [_vm._v("Patient Login")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54ddc395","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/Nav/Nav.pug
// module id = 585
// module chunks = 1